import React from "react";
import { Text, useMantineTheme } from "@mantine/core";

interface LeadProps {
  children: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
}

/**
 * Lead - Larger intro paragraph sitting between a headline and body copy.
 * Enforces the 70ch measure ceiling for comfortable line length.
 * Usage: <Lead>The one-sentence promise of this page.</Lead>
 */
export const Lead: React.FC<LeadProps> = ({ children, className, style }) => {
  const theme = useMantineTheme();
  const other = theme.other as Record<string, string>;

  return (
    <Text
      className={className}
      style={{
        color: other.textPrimary,
        fontSize: "clamp(1.125rem, 1.5vw, 1.25rem)",
        fontWeight: 500,
        lineHeight: 1.55,
        maxWidth: "70ch",
        ...style,
      }}
    >
      {children}
    </Text>
  );
};

export default Lead;
